import React from "react";
import { isEmpty } from "lodash";
import { FieldError, TextField } from "../../../common/fields";

const OtpField = (props) => {
  const { verifyOtpForm, placeholder = "", autoFocus = false, dataAutomationId = "" } = props;
  const onchange = (e) => {
    e.target.value = e.target.value.replace(/\D/g, "");
    verifyOtpForm.handleChange(e);
  };
  const onblur = (e) => {
    if (e.relatedTarget?.type !== "button") {
      verifyOtpForm.handleBlur(e);
    }
  }
  return (
    <div>
      <TextField
        autoFocus={autoFocus} // eslint-disable-line
        type="OTP"
        id="otp"
        name="otp"
        dataAutomationId={dataAutomationId}
        label="Verification Code" valid={!(verifyOtpForm.touched.otp && !isEmpty(verifyOtpForm.errors.otp))}
        onChange={onchange} onBlur={onblur} value={verifyOtpForm.values.otp} maxLength={6}
        placeholder={placeholder}>
        {verifyOtpForm.touched.otp && !isEmpty(verifyOtpForm.errors.otp) &&
          <FieldError name="otp" errors={verifyOtpForm.errors.otp}/>}
      </TextField>
    </div>
  );
};

export default OtpField;